<template>
  <div id="match-list">
    <comp-header
      :pageTitle="headerPageTitle"
      :leftIcon="headerLeftIcon"
      :leftClick="headerLeftAction"
      :rightIcon="headerRightIcon"
      :rightClick="headerRightAction"
    />
    <comp-tab
      :activedTab="selectedListTab"
      @selectedTab="
        tabName => {
          tabSelected(tabName);
        }
      "
    />
    <comp-bottom-tab :tabActive="tab" />
    <template v-if="selectedListTab == 'friend'">
      <comp-list-item
        v-for="data in friendDatas"
        :key="data.mrid"
        :userName="
          data.userseqid == userSeqId
            ? data.matchusername.split('')[0]
            : data.username.split('')[0]
        "
        :fullName="
          data.userseqid == userSeqId ? data.matchusername : data.username
        "
        :matchingRate="data.result"
        :userSeqId="
          data.userseqid == userSeqId ? data.matchuserseqid : data.userseqid
        "
        @getProfile="getProfile"
        @getMatchResult="getMatchResult"
        :rankBtn="rankBtn"
        :rank="data.rank"
        :profileImage="data.matchuserphoto"
        @refreshList="refreshList"
        @wait="startLoading"
        isSwipeEnabled
      />
    </template>
    <template v-else-if="selectedListTab == 'group'">
      <comp-list-item
        v-for="data in groupDatas"
        :key="data.id"
        :itemType="'group'"
        :members="data.users"
        :userName="data.name"
        :fullName="data.name"
        @wait="startLoading"
        @groupItemClicked="goGroupInfoPage(data.id, data.name)"
      />
    </template>
    <comp-match-manage
      v-if="showMatchManageModal"
      @inviteFriend="showModal = true"
      @makeGroup="goMakeGroupPage"
      @close="showMatchManageModal = false"
    ></comp-match-manage>
    <comp-add
      v-if="showModal"
      @stopLoading="stopLoading"
      @urlAdd="urlAdd"
      @performMatch="goMatchingPage"
      @performQr="goQrReader"
      @close="showModal = false"
    >
    </comp-add>
    <comp-modal v-if="copyModal" @confirm="copyModal = !copyModal">
      <p slot="body" v-html="copyModalMsg"></p>
    </comp-modal>
    <comp-loading v-if="isLoading"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompTab from '@/components/CompTab';
import CompListItem from '@/components/CompListItem';
import CompBottomTab from '@/components/CompBottomTab';
import CompMatchManage from '@/components/CompMatchManage';
import CompAdd from '@/components/CompAdd';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import RESPONSE from '@/constants/response';

export default {
  name: 'match-list',
  mixins: [common],
  data() {
    return {
      selectedListTab: this.$store.getters.getLastSelectedMatchTab || 'friend',
      tab: 'match',
      headerPageTitle: this.$i18n.t('match.listHeader'),

      showMatchManageModal: false,
      showModal: false,
      copyModal: false,
      copyModalMsg: '',
      headerLeftIcon: this.$route.query.type ? 'fa-chevron-left' : 'fa-bars',
      headerRightIcon: 'fa-ellipsis-v',
      isLoading: false,

      friendDatas: [],
      groupDatas: [],

      rankBtn: '',
      rank: 0,
      userSeqId: this.$store.getters.getUserSeqId,

      selectedItem: '',
      selectedItems: [],
    };
  },
  components: {
    CompHeader,
    CompTab,
    CompListItem,
    CompBottomTab,
    CompMatchManage,
    CompAdd,
    CompModal,
    CompLoading,
  },
  methods: {
    headerLeftAction() {
      if (this.$route.query.type) {
        this.goPrevious();
      } else {
        this.showMenu();
      }
    },
    headerRightAction() {
      this.showMatchManageModal = true;
    },
    getProfile(id, name) {
      this.$router.push({
        path: `/match/result/${id}/profile`,
        query: { username: name },
      });
    },
    getMatchResult(id, name) {
      this.$router.push({
        path: `/match/result/${id}`,
        query: { username: name },
      });
    },
    startLoading() {
      this.isLoading = true;
    },
    stopLoading() {
      this.isLoading = false;
    },
    refreshList() {
      this.loadList();
    },
    initList(userId) {
      this.startLoading();

      if (this.$route.params.id || userId) {
        const id = this.$route.params.id || userId;
        localStorage.setItem('addUserSeqId', id);
      }
      this.loadList();
    },
    initGroupList(groupId) {
      this.startLoading();

      this.selectedListTab = 'group';
      if (groupId) {
        this.performAddGroup(groupId);
      } else {
        this.getGroupList();
      }
    },
    loadList() {
      this.friendDatas = [];
      this.groupDatas = [];

      const type = this.$route.query.type;
      if (type) {
        this.rankBtn = 'on';
        this.tab = '';
        if (type === '0000000001') {
          this.headerPageTitle = this.$i18n.t('match.spreader');
        } else if (type === '0000000002') {
          this.headerPageTitle = this.$i18n.t('match.stargazer');
        } else if (type === '0000000003') {
          this.headerPageTitle = this.$i18n.t('match.structuralDesigner');
        } else if (type === '0000000004') {
          this.headerPageTitle = this.$i18n.t('match.productPlanner');
        } else if (type === '0000000005') {
          this.headerPageTitle = this.$i18n.t('match.expert');
        } else if (type === '0000000006') {
          this.headerPageTitle = this.$i18n.t('match.executive');
        } else {
          this.headerPageTitle = this.$i18n.t('match.listHeader');
        }
        this.getMc6List();
      } else if (this.selectedListTab === 'group') {
        this.getGroupList();
      } else {
        this.getMatchedList();
      }
    },
    getMatchedList() {
      this.$store.dispatch('getMatchList').then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getMatchedList();
            } else {
              this.invalidateLogin();
            }
          });
        } else if (Object.prototype.hasOwnProperty.call(data, 'data')) {
          this.chkFriendsAvailable();
          this.friendDatas = data.data.data;
        }
        this.stopLoading();
      });
    },
    getMc6List() {
      const type = this.$route.query.type;
      const param = {
        type,
      };
      this.$store.dispatch('getMc6List', param).then(({ data, status }) => {
        if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getMc6List();
            } else {
              this.invalidateLogin();
            }
          });
        } else {
          this.chkFriendsAvailable();
          this.friendDatas = data.data;
        }
        this.stopLoading();
      });
    },
    getGroupList() {
      this.$store.dispatch('getGroupList').then(({ data, status }) => {
        if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getGroupList();
            } else {
              this.invalidateLogin();
            }
          });
        } else {
          this.groupDatas = data.data;
        }
        this.stopLoading();
      });
    },
    tabSelected(tabName) {
      this.selectedListTab = tabName;
      this.$store.commit('setLastSelectedMatchTab', tabName);
      this.loadList();
    },
    chkFriendsAvailable() {
      const friendSeqId = localStorage.getItem('addUserSeqId');
      if (friendSeqId) {
        localStorage.removeItem('addUserSeqId');
        // eslint-disable-next-line
        if (this.$store.getters.getUserSeqId != friendSeqId) {
          this.$store
            .dispatch('addFriend', { friendSeqId })
            .then(({ status, error }) => {
              if (status === 500) {
                this.showCopyDialog('한명이 문제를 다 풀지 않았습니다.');
              } else if (status === 400 && error.resultCode === -200) {
                this.showCopyDialog(error.resultMsg);
              } else if (status === 400 && error.resultCode === -300) {
                this.showCopyDialog(error.resultMsg);
              } else {
                this.showCopyDialog(this.$i18n.t('mc6.friends.done'));

                this.loadList();
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((err) => {
              location.reload();
            });
        }
      }
    },
    urlAdd(link) {
      this.textCopy(link);
      this.showCopyDialog(this.$i18n.t('friends.urlCopy'));
    },
    goMakeGroupPage() {
      this.goPage('/match/make/group');
    },
    goMatchingPage() {
      this.goPage('/match/qr');
    },
    goQrReader() {
      this.$router.push({
        name: 'match-qr',
        params: {
          exec: 'scan',
        },
      });
    },
    goGroupInfoPage(groupId, groupName) {
      this.$router.push({
        path: '/match/group',
        query: {
          groupId,
          groupName,
        },
      });
    },
    performAddGroup(groupId) {
      this.$store
        .dispatch('addMemberImmediately', { groupId })
        // eslint-disable-next-line no-unused-vars
        .then(({ data, status }) => {
          if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.performAddGroup(groupId);
              } else {
                this.invalidateLogin();
              }
            });
          } else if (status === RESPONSE.SUCCESS.CODE) {
            this.showCopyDialog(this.$i18n.t('match.addGroupDone'));

            this.getGroupList();
          } else {
            this.showCopyDialog(data.resultMsg);
          }
        });
    },
    showCopyDialog(message) {
      this.showModal = false;

      this.copyModalMsg = message || 'Error!';
      this.copyModal = true;
    },
  },
  created() {
    if (this.$route.params.redirectInvitePage) {
      this.$router.push({
        path: '/match/invite',
        query: {
          groupId: this.$route.params.groupId,
          groupName: this.$route.params.groupName,
          openType: 'clearTop',
        },
      });
    } else if (this.$route.params.type === 'match') {
      this.initList();
    } else if (this.$route.params.id) {
      this.initGroupList(this.$route.params.id);
    } else {
      this.initList();
    }
  },
};
</script>

<style lang="scss" src="../../scss/match-list.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/match/match-list.vue